import {Calendar} from 'lucide-react'
import {Label} from '@/components/ui/label'
import {ErrorText} from '@/components/shared/ErrorText'
import {InlineRow} from '@/components/shared/InlineRow'
import {Icon} from '@/components/shared/Icon'
import {MutedText} from '@/components/shared/MutedText'
import {DatePicker} from '@/components/shared/DatePicker'
import {AppDate, AppLocalDate} from '@/lib/date-utils'

interface ExpirationDateRowProps {
    value: string
    onChange: (value: string) => void
    required?: boolean
    maxDurationDays?: number | null
    label: string
    maxDurationHint?: string
    testId?: string
}

export function ExpirationDateRow({value, onChange, required, maxDurationDays, label, maxDurationHint, testId}: ExpirationDateRowProps) {
    return (
        <InlineRow gap="sm">
            <Icon icon={Calendar} size="xs" muted/>
            <Label className="text-sm">
                {label}
                {required && <ErrorText className="ml-1">*</ErrorText>}
            </Label>
            <DatePicker
                testId={testId ?? 'expiration-date'}
                value={value}
                onChange={onChange}
                minDate={AppDate.ofLocalDateStr(AppLocalDate.today())}
                maxDate={maxDurationDays != null ? AppDate.ofLocalDateStr(AppLocalDate.maxFromToday(maxDurationDays)) : undefined}
                ariaLabel={label}
                className="h-9 w-auto"
            />
            {maxDurationDays && maxDurationHint && (
                <MutedText size="sm">{maxDurationHint}</MutedText>
            )}
        </InlineRow>
    )
}
